<template>
  <div>
    <v-card flat color="#57bc90" style="min-height: 70vh">
      <v-col>
        <v-data-table
          :headers="InjuriesHeaders"
          :items="injuries"
          :items-per-page="injuries.length"
          class="elevation-1"
          hide-default-footer
        >
          <template v-slot:item.status="{ item }">
            <!-- Blue dot - 'active',
                green dot - 'positive',
                yellow dot -'intermediary'
                red dot - 'negative' -->
            <status-indicator status="negative" pulse class="ml-2" />
          </template>

          <template v-slot:item.InjuryStartDate="{ item }">
            <p class="text-caption">{{ item.InjuryStartDate | dayFormat }}</p>
          </template>

          <!-- player name -->
          <template v-slot:item.name="{ item }">
            <router-link
              :to="{
                name: 'PlayerDetail',
                params: { playerId: item.playerId, SportId: sportId },
              }"
              style="text-decoration: none"
            >
              {{ item.name }}
            </router-link>
          </template>
          <!-- player name ends -->
        </v-data-table>
      </v-col>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "TeamInjuries",
  props: {
    injuries: {
      type: Array,
      default: () => [],
    },
    sportId: {
      type: [String, Number],
      default: () => "",
    },
  },
  data() {
    return {
      InjuriesHeaders: [
        { text: "Date", value: "InjuryStartDate" },
        {
          text: "Position ",
          value: "position",
          sortable: false,
        },
        { text: "Player", value: "name" },
        { text: "Status", value: "status" },
        { text: "Body Part", value: "bodyPart" },
        { text: "Injuries Details", value: "InjuryNotes" },
      ],
    };
  },
};
</script>

<style scoped></style>
